import { useEffect, useState } from 'react';
import { routeToEntity, buildTrustedContextString, type PageEntity } from './buildTrustedContextString';

export function useCurrentPageContext(): string | null {
	const [entity, setEntity] = useState<PageEntity>(() => routeToEntity(window.location.hash));
	useEffect(() => {
		const onHash = () => setEntity(routeToEntity(window.location.hash));
		window.addEventListener('hashchange', onHash);
		return () => window.removeEventListener('hashchange', onHash);
	}, []);
	return buildTrustedContextString(entity);
}
